
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Externalisation RH & Administrative',
      description: 'Libérez du temps pour vos équipes en externalisant les tâches chronophages. De la gestion de la paie aux déclarations sociales, en passant par le recrutement, bénéficiez d\'experts dédiés à moindre coût pour optimiser votre organisation.',
      benefits: [
        'Gestion de la paie externalisée',
        'Recrutement et onboarding',
        'Administration du personnel',
        'Conformité sociale garantie',
      ],
      image: 'https://public.readdy.ai/ai/img_res/927ae93efe7a32fb06971cea19c4b2f5.jpg',
    },
    {
      number: '02',
      title: 'Audit Commercial Qualitatif',
      description: 'Identifiez vos leviers de croissance avec un audit commercial approfondi et sans superflu. Analyse de votre processus de vente, de votre positionnement marché et de vos opportunités de développement pour des résultats concrets et mesurables.',
      benefits: [
        'Analyse du processus commercial',
        'Étude de positionnement',
        'Plan d\'action personnalisé',
        'Suivi des performances',
      ],
      image: 'https://readdy.ai/api/search-image?query=Business%20consultant%20presenting%20sales%20analysis%20and%20growth%20charts%20on%20large%20screen%20in%20modern%20boardroom%2C%20professional%20audit%20meeting%20with%20graphs%20and%20performance%20metrics%2C%20strategic%20business%20planning%20session%2C%20bright%20corporate%20environment%2C%20high%20quality%20professional%20photography&width=800&height=600&seq=tpe-audit-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Formations Sur-Mesure',
      description: 'Investissez dans la montée en compétences de vos collaborateurs avec des formations adaptées à vos besoins réels. Techniques de vente, management, outils digitaux : des programmes personnalisés pour des résultats durables et une équipe performante.',
      benefits: [
        'Programmes personnalisés',
        'Formations inter et intra',
        'Certifications reconnues',
        'Suivi post-formation',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20training%20session%20in%20modern%20conference%20room%2C%20instructor%20teaching%20engaged%20employees%20with%20presentation%20and%20interactive%20workshop%2C%20collaborative%20learning%20environment%2C%20bright%20training%20facility%2C%20high%20quality%20educational%20corporate%20photography&width=800&height=600&seq=tpe-formation-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'E-réputation & Visibilité',
      description: 'Développez votre présence en ligne et attirez une clientèle ciblée. Stratégie de contenu, gestion des avis clients, référencement local et réseaux sociaux : construisez une image de marque forte qui génère des opportunités commerciales.',
      benefits: [
        'Stratégie de contenu digital',
        'Gestion des avis clients',
        'Référencement local optimisé',
        'Animation réseaux sociaux',
      ],
      image: 'https://readdy.ai/api/search-image?query=Digital%20marketing%20team%20working%20on%20online%20reputation%20strategy%20with%20multiple%20screens%20showing%20social%20media%20analytics%20and%20customer%20reviews%2C%20modern%20tech%20office%20environment%2C%20professional%20digital%20marketing%20workspace%2C%20bright%20contemporary%20setting%2C%20high%20quality%20business%20photography&width=800&height=600&seq=tpe-digital-001&orientation=landscape',
    },
    {
      number: '05',
      title: 'Optimisation Fiscale & Sociale',
      description: 'Réduisez vos charges tout en restant conforme. Nos experts vous accompagnent dans l\'optimisation de vos charges patronales, l\'identification des aides disponibles et la mise en place de solutions adaptées à votre structure pour améliorer votre rentabilité.',
      benefits: [
        'Audit des charges sociales',
        'Identification des aides',
        'Optimisation fiscale légale',
        'Conseil en financement',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20advisor%20consulting%20with%20business%20owner%20reviewing%20tax%20optimization%20documents%20and%20financial%20reports%20in%20modern%20office%2C%20organized%20desk%20with%20calculator%20and%20charts%2C%20professional%20business%20consultation%2C%20natural%20lighting%2C%20high%20quality%20corporate%20photography&width=800&height=600&seq=tpe-fiscal-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les TPE / PME
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Des services complets pour accélérer votre développement
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
